import store from '@/store'

export default (Vue) => {
  Vue.directive('auth', {
    inserted: function (el, binding) {
      if (store.state.authMap[binding.value] != 1) {
        el.style.display = 'none'
      } else {
      }
    }
  })
}
